/**
 * Created by cookiecoffee on 2018/2/7.
 */
import Vue from 'vue'
// const Vue = require('vue')
const domain = process.env.NODE_ENV === 'development' ? '//www.test.51offer.com' : ''
// 获取字典
const GET_NOTES = domain + '/ngGpaCalc/constants'
// 百分制
const GET_BAI = domain + '/ngGpaCalc/gpabai'
// 五分制
const GET_WU = domain + '/ngGpaCalc/gpawu'
// 等级制
const GET_LEVEL = domain + '/ngGpaCalc/gpalevel'
// 获取三滑下拉选项
const GET_LIST_AJAX = domain + '/threeSteps/getOneStep.do'
// 获取留学计划
const UPDATE_OTHER_AJAX = domain + '/threeStepOther/updateOneStepOther.do'
// 获取留学数目
const ARTICLE_AJAX = domain + '/article/getLevelCategoryDetailByKey.html?key=' + encodeURIComponent('common_all_offer')

export const getnotes = (opt) => Vue.axios.get(GET_NOTES, opt)
export const getbai = (opt) => Vue.axios.post(GET_BAI, opt)
export const getwu = (opt) => Vue.axios.post(GET_WU, opt)
export const getlevel = (opt) => Vue.axios.post(GET_LEVEL, opt)
export const getpalanlist = (opt) => Vue.axios.get(GET_LIST_AJAX, opt)
export const getpalan = (opt) => Vue.axios.post(UPDATE_OTHER_AJAX, opt)
export const getarticle = (opt) => Vue.axios.get(ARTICLE_AJAX, opt)



// WEBPACK FOOTER //
// ./src/libs/api.js